import type { Role } from '@/entities/user';

export const couponsAccessRoles = ['admin'] as const satisfies readonly Role[];
